module.exports = __webpack_public_path__ + "img/rightmark.fdc8e73c.svg";